/**
 * User role enumeration
 */
export enum UserRole {
    SYSTEM = 'SYSTEM',
    DONOR = 'DONOR'
}

/**
 * User interface representing a user in the system
 */
export interface User {
    id: number;
    supplierId?: string | null;
    supplierCode?: string | null;
    email: string;
    name: string;
    profileImageURL?: string | null;
    contactNumber: string;
    role: UserRole | string;
    language: string;
    lastAccess: string | Date;
    active: boolean;
    languageCode?: string;
    referrer?: string | null;
    address?: {
        id?: number;
        address?: string;
        postalCode?: string;
        city?: string;
        country?: string;
        lattitude?: string;
        longtitude?: string;
        type?: string;
        languageCode?: string;
        user?: string;
    }[];
}

/**
 * Interface for creating a new user
 */
export interface UserCreateRequest {
    email: string;
    name: string;
    contactNumber: string;
    role: UserRole;
    language: string;
    password?: string;
    active?: boolean;
    languageCode?: string;
}

/**
 * Interface for updating an existing user
 */
export interface UserUpdateRequest {
    id: number;
    email?: string;
    name?: string;
    contactNumber?: string;
    role?: UserRole;
    language?: string;
    active?: boolean;
    languageCode?: string;
}

/**
 * Interface for filtering users
 */
export interface UserFilter {
    search?: string;
    name?: string;
    email?: string;
    role?: UserRole;
    active?: boolean;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
}

/**
 * Interface for user list response with pagination
 */
export interface UserListResponse {
    users: User[];
    totalCount: number;
}